import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { DriverLicenceSummary, LicenceExpiryRiskLevel } from '../../../model/licence.model';

@Component({
  selector: 'vrm-driver-licence-summary',
  templateUrl: './driver-licence-summary.component.html',
  styleUrls: ['./driver-licence-summary.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DriverLicenceSummaryComponent {
  @Input() public dataSource: DriverLicenceSummary[] = [];
  protected LicenceExpiryRiskLevel = LicenceExpiryRiskLevel;
  protected columns = [
    'firstName',
    'lastName',
    'pin',
    'lastCheckDate',
    'mandateExpiryDate',
    'licenceExpiryDate',
    'issueNumber',
    'licenceStatus',
  ];
}
